(function () {
  "use strict";

  var CHEVRON_SVG =
    '<svg width="11" height="16" viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M2.2 1.2L8.8 8L2.2 14.8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var DRAG_IGNORE_PX = 8;
  var SWIPE_PX = 50;

  var instances = {};
  var idCounter = 0;
  var activeGalleryId = null;
  var lightboxIndex = 0;
  var lightboxEl = null;
  var lightboxImg = null;
  var lightboxPrevBtn = null;
  var lightboxNextBtn = null;
  var previousFocus = null;
  var lockedScrollY = 0;

  function wrapIndex(index, count) {
    if (count <= 0) {
      return 0;
    }

    return ((index % count) + count) % count;
  }

  function getGalleryId(el) {
    var id = el.getAttribute("data-gallery-id") || el.id;

    if (!id) {
      idCounter += 1;
      id = "gallery-" + idCounter;
    }

    el.id = id;
    el.setAttribute("data-gallery-id", id);

    return id;
  }

  function collectSources(items) {
    var sources = [];
    var i;
    var img;

    for (i = 0; i < items.length; i++) {
      img = items[i].querySelector("img");
      sources.push({
        src: img ? img.getAttribute("src") || "" : "",
        alt: img ? img.getAttribute("alt") || "" : "",
      });
    }

    return sources;
  }

  function getFocusable(root) {
    var nodes = root.querySelectorAll(
      'button:not([disabled]):not([hidden]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    var out = [];
    var i;
    var node;

    for (i = 0; i < nodes.length; i++) {
      node = nodes[i];
      if (node.hidden || node.getAttribute("aria-hidden") === "true") {
        continue;
      }
      out.push(node);
    }

    return out;
  }

  function lockScroll() {
    lockedScrollY = window.scrollY || document.documentElement.scrollTop || 0;
    document.documentElement.classList.add("has-gallery-open");
    document.body.classList.add("has-gallery-open");

    if (window.lenis && typeof window.lenis.stop === "function") {
      window.lenis.stop();
    }
  }

  function unlockScroll() {
    document.documentElement.classList.remove("has-gallery-open");
    document.body.classList.remove("has-gallery-open");

    if (window.lenis && typeof window.lenis.start === "function") {
      window.lenis.start();
    }

    window.scrollTo(0, lockedScrollY);
  }

  function ensureLightbox() {
    if (lightboxEl) {
      return lightboxEl;
    }

    lightboxEl = document.createElement("div");
    lightboxEl.id = "gallery-lightbox";
    lightboxEl.className = "galleryLightbox";
    lightboxEl.setAttribute("role", "dialog");
    lightboxEl.setAttribute("aria-modal", "true");
    lightboxEl.setAttribute("aria-hidden", "true");
    lightboxEl.setAttribute("aria-label", "Image gallery");
    lightboxEl.tabIndex = -1;
    lightboxEl.innerHTML =
      '<div class="galleryLightbox__backdrop"></div>' +
      '<button type="button" class="galleryLightbox__arrow galleryLightbox__arrow--prev" aria-label="Previous image">' +
      CHEVRON_SVG +
      "</button>" +
      '<div class="galleryLightbox__stage"><img alt="" /></div>' +
      '<button type="button" class="galleryLightbox__arrow galleryLightbox__arrow--next" aria-label="Next image">' +
      CHEVRON_SVG +
      "</button>";

    document.body.appendChild(lightboxEl);

    lightboxImg = lightboxEl.querySelector(".galleryLightbox__stage img");
    lightboxPrevBtn = lightboxEl.querySelector(".galleryLightbox__arrow--prev");
    lightboxNextBtn = lightboxEl.querySelector(".galleryLightbox__arrow--next");

    lightboxEl.addEventListener("click", function (event) {
      if (
        event.target.closest(".galleryLightbox__stage") ||
        event.target.closest(".galleryLightbox__arrow")
      ) {
        return;
      }

      closeLightbox();
    });

    lightboxPrevBtn.addEventListener("click", function (event) {
      event.preventDefault();
      lightboxGoTo(lightboxIndex - 1);
    });

    lightboxNextBtn.addEventListener("click", function (event) {
      event.preventDefault();
      lightboxGoTo(lightboxIndex + 1);
    });

    return lightboxEl;
  }

  function renderLightbox() {
    var inst = instances[activeGalleryId];
    var source;
    var showNav;

    if (!inst || !lightboxEl || !lightboxImg) {
      return;
    }

    source = inst.sources[lightboxIndex];

    if (!source) {
      return;
    }

    lightboxImg.src = source.src;
    lightboxImg.alt = source.alt || "";
    showNav = inst.sources.length > 1;
    lightboxPrevBtn.hidden = !showNav;
    lightboxNextBtn.hidden = !showNav;
    lightboxEl.classList.toggle("is-single", !showNav);
  }

  function lightboxGoTo(index) {
    var inst = instances[activeGalleryId];

    if (!inst) {
      return;
    }

    lightboxIndex = wrapIndex(index, inst.sources.length);
    inst.goTo(lightboxIndex);
    renderLightbox();
  }

  function openLightbox(galleryId, index) {
    var inst = instances[galleryId];
    var focusable;

    if (!inst || !inst.sources.length) {
      return;
    }

    ensureLightbox();
    activeGalleryId = galleryId;
    lightboxIndex = wrapIndex(index, inst.sources.length);
    previousFocus = document.activeElement;
    renderLightbox();
    lightboxEl.classList.add("is-open");
    lightboxEl.setAttribute("aria-hidden", "false");
    lockScroll();

    focusable = getFocusable(lightboxEl);
    (focusable[0] || lightboxEl).focus();
  }

  function closeLightbox() {
    var inst;

    if (!activeGalleryId || !lightboxEl) {
      return;
    }

    inst = instances[activeGalleryId];

    if (inst) {
      inst.goTo(lightboxIndex);
    }

    lightboxEl.classList.remove("is-open");
    lightboxEl.setAttribute("aria-hidden", "true");
    unlockScroll();
    activeGalleryId = null;

    if (previousFocus && typeof previousFocus.focus === "function") {
      previousFocus.focus();
    }

    previousFocus = null;
  }

  function trapFocus(event) {
    var focusable;
    var first;
    var last;

    if (!lightboxEl) {
      return;
    }

    focusable = getFocusable(lightboxEl);

    if (!focusable.length) {
      event.preventDefault();
      lightboxEl.focus();
      return;
    }

    first = focusable[0];
    last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function buildNav(id, count, trackId) {
    var nav = document.createElement("div");
    var dots = document.createElement("div");
    var prev = document.createElement("button");
    var next = document.createElement("button");
    var i;
    var dot;

    nav.className = "galleryNav";
    nav.setAttribute("data-gallery-id", id);

    prev.type = "button";
    prev.className = "galleryNav__arrow galleryNav__arrow--prev";
    prev.setAttribute("aria-label", "Previous image");
    prev.setAttribute("aria-controls", trackId);
    prev.innerHTML = CHEVRON_SVG;

    next.type = "button";
    next.className = "galleryNav__arrow galleryNav__arrow--next";
    next.setAttribute("aria-label", "Next image");
    next.setAttribute("aria-controls", trackId);
    next.innerHTML = CHEVRON_SVG;

    dots.className = "galleryNav__dots";
    dots.setAttribute("role", "tablist");

    for (i = 0; i < count; i++) {
      dot = document.createElement("button");
      dot.type = "button";
      dot.className = "galleryNav__dot";
      dot.setAttribute("data-gallery-index", String(i));
      dot.setAttribute("aria-label", "Show image " + (i + 1));
      dots.appendChild(dot);
    }

    nav.appendChild(prev);
    nav.appendChild(dots);
    nav.appendChild(next);

    return nav;
  }

  function initGallery(el) {
    var id;
    var track;
    var items;
    var sources;
    var count;
    var index = 0;
    var nav = null;
    var didDrag = false;
    var startX = 0;
    var instance;

    if (!el || el.getAttribute("data-gallery-bound") === "1") {
      return;
    }

    track = el.querySelector(".galleryItemList");
    items = el.querySelectorAll(".galleryItem");

    if (!track || !items.length) {
      return;
    }

    id = getGalleryId(el);
    sources = collectSources(items);
    count = sources.length;
    track.id = id + "-track";

    el.setAttribute("role", "region");
    el.setAttribute("aria-roledescription", "carousel");
    el.setAttribute("aria-label", "Image gallery");
    el.classList.toggle("is-single", count === 1);

    function syncDots() {
      var dots;
      var i;

      if (!nav) {
        return;
      }

      dots = nav.querySelectorAll(".galleryNav__dot");

      for (i = 0; i < dots.length; i++) {
        if (i === index) {
          dots[i].setAttribute("aria-current", "true");
        } else {
          dots[i].removeAttribute("aria-current");
        }
      }
    }

    function goTo(nextIndex) {
      index = wrapIndex(nextIndex, count);
      track.style.transform = "translateX(-" + index * 100 + "%)";
      syncDots();
    }

    function onItemActivate(item) {
      var i;
      var itemIndex = index;

      for (i = 0; i < items.length; i++) {
        if (items[i] === item) {
          itemIndex = i;
          break;
        }
      }

      openLightbox(id, itemIndex);
    }

    if (count > 1) {
      nav = buildNav(id, count, track.id);
      el.appendChild(nav);

      nav
        .querySelector(".galleryNav__arrow--prev")
        .addEventListener("click", function (event) {
          event.preventDefault();
          event.stopPropagation();
          goTo(index - 1);
        });

      nav
        .querySelector(".galleryNav__arrow--next")
        .addEventListener("click", function (event) {
          event.preventDefault();
          event.stopPropagation();
          goTo(index + 1);
        });

      nav.addEventListener("click", function (event) {
        var dot = event.target.closest(".galleryNav__dot");
        var dotIndex;

        if (!dot) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        dotIndex = parseInt(dot.getAttribute("data-gallery-index"), 10);

        if (!isNaN(dotIndex)) {
          goTo(dotIndex);
        }
      });
    }

    Array.prototype.forEach.call(items, function (item) {
      item.setAttribute("role", "button");
      item.setAttribute("tabindex", "0");

      item.addEventListener("click", function () {
        if (didDrag) {
          didDrag = false;
          return;
        }

        onItemActivate(item);
      });

      item.addEventListener("keydown", function (event) {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onItemActivate(item);
        }
      });
    });

    track.addEventListener("pointerdown", function (event) {
      if (event.pointerType === "mouse" && event.button !== 0) {
        return;
      }

      startX = event.clientX;
      didDrag = false;
    });

    track.addEventListener("pointerup", function (event) {
      var dx = event.clientX - startX;

      if (Math.abs(dx) > DRAG_IGNORE_PX) {
        didDrag = true;
      }

      if (count > 1 && Math.abs(dx) > SWIPE_PX) {
        goTo(dx < 0 ? index + 1 : index - 1);
      }
    });

    track.addEventListener("pointercancel", function () {
      didDrag = false;
    });

    if (typeof ResizeObserver === "function") {
      new ResizeObserver(function () {
        goTo(index);
      }).observe(el);
    }

    goTo(0);
    el.setAttribute("data-gallery-bound", "1");

    instance = {
      el: el,
      id: id,
      sources: sources,
      goTo: goTo,
      openLightbox: function (i) {
        openLightbox(id, i);
      },
    };

    instances[id] = instance;
  }

  function initGalleries() {
    var nodes = document.querySelectorAll(".galleryWrp");
    var i;

    ensureLightbox();

    for (i = 0; i < nodes.length; i++) {
      initGallery(nodes[i]);
    }
  }

  document.addEventListener("keydown", function (event) {
    if (!activeGalleryId) {
      return;
    }

    if (event.key === "Escape") {
      event.preventDefault();
      closeLightbox();
      return;
    }

    if (event.key === "ArrowLeft") {
      event.preventDefault();
      lightboxGoTo(lightboxIndex - 1);
      return;
    }

    if (event.key === "ArrowRight") {
      event.preventDefault();
      lightboxGoTo(lightboxIndex + 1);
      return;
    }

    if (event.key === "Tab") {
      trapFocus(event);
    }
  });

  window.initGalleries = initGalleries;
  window.closeGalleryLightbox = closeLightbox;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initGalleries);
  } else {
    initGalleries();
  }
})();
